import apiClient from "../../api/api";

/**
 * @description Fetches the compliance settings configuration.
 *
 * @async
 * @function requestGetComplianceSettings
 * @returns {Promise<any>} A promise that resolves with the compliance settings data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestGetComplianceSettings = async() => {
    const getComplianceSettingsResponse = await apiClient.get(import.meta.env.VITE_BASE_COMPLIANCE_SETTING_URL)

    return getComplianceSettingsResponse.data[0]
}

/**
 * @description Updates the compliance settings configuration.
 *
 * @async
 * @function requestUpdateComplianceSettings
 * @param {Object} complianceSettings - The compliance settings payload to be updated.
 *
 * @returns {Promise<any>} A promise that resolves with the updated compliance settings data.
 *
 * @throws {Error} Throws an error if the API request fails.
 */
export const requestUpdateComplianceSettings = async(complianceSettings) => {
    const updateComplianceSettingsResponse = await apiClient.put(import.meta.env.VITE_BASE_COMPLIANCE_SETTING_URL, complianceSettings, {successToast:"Compliance settings updated"})

    return updateComplianceSettingsResponse.data
}